import type { PropsWithChildren } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

const HasStoreBannerContext = createContext<{
  hasStoreBanner: boolean;
  setHasStoreBanner: (hasStoreBanner: boolean) => void;
}>({ hasStoreBanner: false, setHasStoreBanner: () => {} });

export const HasStoreBannerProvider = ({ children }: PropsWithChildren) => {
  const [hasStoreBanner, setHasStoreBanner] = useState(false);
  const contextValue = useMemo(
    () => ({ hasStoreBanner, setHasStoreBanner }),
    [hasStoreBanner, setHasStoreBanner]
  );

  return (
    <HasStoreBannerContext.Provider value={contextValue}>
      {children}
    </HasStoreBannerContext.Provider>
  );
};

export const useHasStoreBanner = () => useContext(HasStoreBannerContext);
